import { useCallback, useEffect, useState } from "react";
import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";

import Domain from "../../services/domain";
import PubSub from "../../services/PubSub";
import RadioButtonList from "../controls/form/RadioButtonList";
import { useGetDomain } from "../../common/Hooks";

const DeleteDomain = ({ show, onCancel = () => { } }) => {
    const [domains, setDomains] = useState([]);
    const [selectedDomain, setSelectedDomain] = useState("");
    const [{ _id: currentDomain }] = useGetDomain();
    const [translate] = useTranslation();

    const populateDomains = useCallback(async () => {
        const response = await Domain.getAllDomains();
        if (!response.error) {
            setDomains([...response.data.filter(domain => !domain.rootDomain)]);
            if (currentDomain) {
                setSelectedDomain(currentDomain);
            }
        }
    }, [currentDomain, setDomains, setSelectedDomain]);

    useEffect(() => {
        if (show) {
            populateDomains();
        }
    }, [show, populateDomains]);

    const deleteDomain = useCallback(async () => {
        if (selectedDomain) {
            const response = await Domain.deleteDomain(selectedDomain);
            if (!response.error) {
                PubSub.publish("refresh-domain-list", { domainDeleted: true, deletedDomainId: selectedDomain });
                onCancel();
            }
        }
    }, [selectedDomain, onCancel]);

    return (
        <BootstrapModal show={show} backdrop="static">
            <Formik initialValues={{
                domain: [...domains]
            }} onSubmit={deleteDomain} enableReinitialize>
                <Form>
                    <BootstrapModal.Header className="h5 text-secondary">{translate("OTM_DELETE_DOMAIN")}</BootstrapModal.Header>
                    <BootstrapModal.Body>
                        <RadioButtonList name="domain" heading={translate("OTM_SELECT_A_DOMAIN")} onSelect={(selected) => setSelectedDomain(selected)} />
                    </BootstrapModal.Body>
                    <BootstrapModal.Footer>
                        <Button type="submit" className="btn btn-danger btn-sm" disabled={!selectedDomain}>{translate("OTM_DELETE")}</Button>
                        <Button onClick={onCancel} variant="secondary" className="btn-sm">{translate("OTM_CANCEL")}</Button>
                    </BootstrapModal.Footer>
                </Form>
            </Formik>
        </BootstrapModal>
    );
};

export default DeleteDomain;